import { render, staticRenderFns } from "./ManualNorm.vue?vue&type=template&id=0f2b07fa&scoped=true"
import script from "./ManualNorm.vue?vue&type=script&lang=js"
export * from "./ManualNorm.vue?vue&type=script&lang=js"
import style0 from "./ManualNorm.vue?vue&type=style&index=0&id=0f2b07fa&prod&lang=scss&scoped=true"
import style1 from "./ManualNorm.vue?vue&type=style&index=1&id=0f2b07fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b07fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
